import { httpClient } from '../http-client.service';

export interface PushSubscriptionPayload {
  endpoint: string;
  expirationTime: number | null;
  keys: { p256dh: string; auth: string };
}

export interface PushSubscriptionEntity extends PushSubscriptionPayload {
  id?: string;
  userId?: string;
  createdAt?: string;
}

export const pushApi = {
  async subscribe(payload: PushSubscriptionPayload) {
    const res = await httpClient.post<{ data?: unknown }>('/notifications/push/subscribe', payload);
    const data = res.data;
    return (data as any)?.data ?? data;
  },

  async unsubscribe(endpoint: string) {
    const res = await httpClient.delete<{ data?: unknown }>('/notifications/push/unsubscribe', {
      params: { endpoint },
    });
    const data = res.data;
    return (data as any)?.data ?? data;
  },

  async list(): Promise<PushSubscriptionEntity[]> {
    const res = await httpClient.get<{ data?: PushSubscriptionEntity[] } | PushSubscriptionEntity[]>('/notifications/push/subscriptions');
    const responseData = res.data;
    const payload = (responseData as any)?.data ?? responseData;
    return Array.isArray(payload) ? payload : (payload as any)?.subscriptions ?? [];
  },

  async sendTest(userId: string) {
    // AD-214: тело — пустой объект. На `null` строгий JSON-парсер бэкенда отвечает 400.
    const res = await httpClient.post<{ data?: unknown }>('/notifications/push/test', {}, {
      params: { userId },
    });
    const data = res.data;
    return (data as any)?.data ?? data;
  },
};

export default pushApi;


